module.exports = __webpack_public_path__ + "static/img/proceeding.4665df1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/proceeding.jpg
// module id = sMFh
// module chunks = 4